import React, { useState } from 'react';

function SponsorBanner() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative w-1100 h-40 top-3395 left-171 flex justify-center mb-5 mt-10 items-center bg-gray-300"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="text-gray-800 text-sm font-semibold">
        {isHovered ? "Coming soon..." : "Sponsor"}
      </div>
    </div>
  );
}

export default SponsorBanner;
